export const openContact = link => {
  window.open(link);
};

export const getContact = type => {
  if (type.emailAddress) {
    return `mailto:${type.emailAddress}?subject=${type.subject}`;
  }
  if (type.phoneNumber) {
    return `tel:${type.phoneNumber}`;
  }
};
